export const headers = {
  State: {
    name: "state",
    width: 0.6,
    textAlign: "left",
  },
  Warehouse: {
    name: "warehouse",
    width: 0.8,
    textAlign: "left",
  },
  CustomerName: {
    name: "customerName",
    width: 2.0,
    textAlign: "left",
  },
  DocNum: {
    name: "documentNo",
    width: 0.8,
    textAlign: "left",
  },
  CustomerPortalOrderNo: {
    name: "portalOrderNo",
    width: 0.8,
    textAlign: "left",
  },
  DocType: {
    name: "document",
    width: 1.0,
    textAlign: "left",
  },
  OrderStatus: {
    name: "orderStatus",
    width: 0.8,
    textAlign: "left",
  },
  RequestDate: {
    name: "requestDate",
    width: 1.0,
    textAlign: "left",
    isSort: true,
    sortDirection: "asc",
  },
  ShippingType: {
    name: "shippingType",
    width: 1.0,
    textAlign: "left",
  },
  ShipToCode: {
    name: "shippingCode",
    width: 1.3,
    textAlign: "left",
  },
  SalesPerson: {
    name: "sales",
    width: 1.1,
    textAlign: "left",
  },
  ProcessBy: {
    name: "operator",
    width: 1.0,
    textAlign: "left",
  },
  "": { name: "", width: 0.8, textAlign: "" },
};

export const mdHeaders = {
  Warehouse: {
    name: "warehouse",
    width: 0.8,
    isSort: true,
    textAlign: "left",
  },
  CustomerCode: {
    name: "customerCode",
    width: 1.0,
    textAlign: "left",
  },
  CustomerName: {
    name: "customerName",
    width: 2.5,
    textAlign: "center",
  },
  ShippingType: {
    name: "shippingType",
    width: 1.0,
    textAlign: "center",
  },
  ShipToCode: {
    name: "shippingCode",
    width: 1.2,
    textAlign: "center",
  },
  "": { name: "", width: 0.8, textAlign: "" },
};

export const smHeaders = {
  Warehouse: {
    name: "warehouse",
    width: 0.9,
    isSort: true,
    textAlign: "left",
  },
  CustomerName: {
    name: "customerName",
    width: 1.2,
    textAlign: "left",
  },
  DocNum: {
    name: "documentNo",
    width: 0.8,
    textAlign: "left",
  },
  "": { name: "", width: 1.0, textAlign: "" },
};

export const phoneHeaders = {
  CustomerName: {
    name: "customerName",
    width: 1.2,
    textAlign: "left",
  },
  DocNum: {
    name: "documentNo",
    width: 0.8,
    textAlign: "left",
  },
  "": { name: "", width: 1.2, textAlign: "" },
};

export const stockTransferPhoneHeaders = {
  Warehouse: {
    name: "warehouse",
    width: 1.0,
    isSort: true,
    textAlign: "left",
  },
  DocNum: {
    name: "documentNo",
    width: 0.8,
    textAlign: "left",
  },
  DocType: {
    name: "document",
    width: 1.0,
    textAlign: "left",
  },
  "": { name: "", width: 0.5, textAlign: "" },
};
